import { useTranslation } from "react-i18next";
import { localDateTime } from "../../../lib/datetime";
import { CheckCircle2, Timer, XCircle } from "lucide-react";
import { NeuCard } from "../../../components/neu/Neu";

export const CronCard = ({ data, onOpen }) => {
  const { t } = useTranslation();
  if (!data) return null;

  return (
    <NeuCard
      data-testid="system-cron-card"
      onClick={onOpen}
      className="cursor-pointer transition-transform duration-300 hover:-translate-y-0.5"
    >
      <p className="label-xs flex items-center gap-2">
        <Timer className="h-4 w-4 text-primary" /> {t("system.crons")}
      </p>

      {!data.jobs.length ? (
        <p className="mt-4 text-sm text-muted-foreground" data-testid="system-cron-empty">
          {t("system.noCronRuns")}
        </p>
      ) : (
        <ul className="mt-4 grid gap-2" data-testid="system-cron-list">
          {data.jobs.map((job) => (
            <li key={job.job} className="rounded-2xl bg-background px-3 py-2.5 shadow-neu-sm">
              <div className="flex items-center justify-between gap-3">
                <p className="flex items-center gap-2 truncate text-xs font-bold">
                  {job.ok ? (
                    <CheckCircle2 className="h-4 w-4 shrink-0 text-primary" />
                  ) : (
                    <XCircle className="h-4 w-4 shrink-0 text-destructive" />
                  )}
                  {job.job}
                </p>
                <p className="shrink-0 font-mono text-[10px] text-muted-foreground num">
                  {localDateTime(job.at)} · {job.ms} ms
                </p>
              </div>
              {job.failures ? (
                <p className="mt-1 text-[11px] font-bold text-destructive">
                  {t("system.cronFailures", { count: job.failures })}
                </p>
              ) : null}
              {job.detail ? (
                <p className="mt-1 truncate font-mono text-[10px] text-muted-foreground num">
                  {job.detail}
                </p>
              ) : null}
            </li>
          ))}
        </ul>
      )}
    </NeuCard>
  );
};
